import React from "react"

import { buildQuery, compress, useQuery } from "micro-graphql-react"

import { studentClient as client } from "src/graphql-config"

import WithLoadingIndicator from "components/WithLoadingIndicator"

import AddTeacherSubject from "./AddTeacherSubject"
import CurrentTeacherSubjects from "./CurrentTeacherSubjects"

const EditTeacherSubjects = () => {
  const loadingState = useQuery(
    buildQuery(
      teacherSubjectsQuery,
      {},
      {
        client,
        onMutation: [
          {
            when: "teacherSubjectRemove",
            run: ({ softReset, currentResults }, response) => {
              const { removedTeacherSubjectId } = response.teacherSubjectRemove
              if (!removedTeacherSubjectId) return
              currentResults.viewer.teacherSubjects =
                currentResults.viewer.teacherSubjects.filter(
                  ts => ts.id !== removedTeacherSubjectId
                )
              softReset(currentResults)
            },
          },
          {
            when: "teacherSubjectAdd",
            run: ({ softReset, currentResults }, response) => {
              const { teacherSubject } = response.teacherSubjectAdd
              if (!teacherSubject) return
              currentResults.viewer.teacherSubjects.push(teacherSubject)
              softReset(currentResults)
            },
          },
        ],
      }
    )
  )

  return (
    <WithLoadingIndicator loadingState={loadingState}>
      {({ data }) => (
        <>
          <CurrentTeacherSubjects
            teacherSubjects={data.viewer.teacherSubjects}
          />
          <AddTeacherSubject teachers={data.viewer.accessibleTeachers} />
          <div className="mt-3">
            <a href="/" className="btn solid blue">
              Done
            </a>
          </div>
        </>
      )}
    </WithLoadingIndicator>
  )
}

const teacherSubjectsQuery = compress`
  query {
    viewer {
      teacherSubjects {
        id
        teacher {
          id
          fullName
          lastName
        }
        subject {
          id
          name
        }
      }
      accessibleTeachers {
        id
        fullName
        lastName
        teacherSubjects {
          id
          subject {
            id
            name
          }
        }
      }
    }
  }
`

export default EditTeacherSubjects
